module.exports = __webpack_public_path__ + "img/active-en.ef79257c.jpg";